// src/components/common/UI/Section.jsx
import React from 'react';

export const Section = ({ 
  children, 
  id, 
  className = '', 
  background = 'default',
  padding = 'default' 
}) => {
  const backgrounds = {
    default: 'bg-white dark:bg-gray-900',
    alt: 'bg-gray-50 dark:bg-gray-800',
    gradient: 'bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800'
  };
  
  const paddings = {
    sm: 'py-12',
    default: 'py-20',
    lg: 'py-32',
    none: ''
  };
  
  return (
    <section 
      id={id}
      className={`${backgrounds[background]} ${paddings[padding]} ${className}`}
    >
      {children}
    </section>
  );
};